// extracted by mini-css-extract-plugin
export default {"card":"VehicleCard_card__ec6+e","header":"VehicleCard_header__9PxKT","assignBtn":"VehicleCard_assignBtn__nsbrD","buttons":"VehicleCard_buttons__ty+4z"};